import React from 'react';
import {Button, Modal} from 'antd';
import {t} from '../../i18n';

/**
 * 「账号被禁止申报」提示弹窗。
 *
 * 样式随项目弹窗范式（见 WorkProgressBagDownloadModal）：标题左侧紫色竖线、宽 600、
 * 关键信息用灰底块托出、footer 自定义按钮。不用 Modal.error —— 它的红色大图标
 * 与项目其余弹窗形态不一致。
 */
export interface PodExemptReporterBlockedModalProps {
  visible: boolean;
  onClose: () => void;
}

const PodExemptReporterBlockedModal: React.FC<PodExemptReporterBlockedModalProps> = ({
  visible,
  onClose,
}) => (
  <Modal
    title={
      <div className="flex items-center">
        <div className="w-1 h-6 bg-purple-500 mr-3"></div>
        <span className="text-lg font-medium">{t('podExempt.create.reporterBlockedTitle')}</span>
      </div>
    }
    open={visible}
    onCancel={onClose}
    width={600}
    footer={[
      <Button key="ok" type="primary" onClick={onClose}>
        {t('podExempt.create.reporterBlockedGotIt')}
      </Button>,
    ]}
  >
    <div className="py-4">
      <p className="text-gray-800 font-medium mb-4">
        {t('errors.business.podExempt.reporterBlocked')}
      </p>
    </div>
  </Modal>
);

export default PodExemptReporterBlockedModal;
